import { getS3Image } from "./awsLib";
import icAvatar from "../assets/ic-avatar.png"

export function processQuestions(questions) {
  return Promise.all(questions.map(async poll => {
    if (poll.author.UID === '073125a3-6b49-4e14-9f9c-d7bbdb6045f3' ||
        poll.author.UID === '96d40aa8-7d4c-4093-bfbd-07a155adddae') // if icitizen account (load static image)
      poll.author.avatarURL = icAvatar;
    else  
      poll.author.avatarURL = await getS3Image(poll.author.UID);
    return poll
  }));
}